// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Vl5Y","type":"styles_type__3Dxjz","choices":"styles_choices__sEMBI"};